import React, { Component } from "react";
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import ConfirmarOperacionTransfer from "../../../pages/transferencias/ConfirmarOperacionTransfer"; 
import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import { splitImporte } from "../../../generico/utils/FormatoInput";

export default class TransferCuentasPropias extends Component {
  TIPO_DEBITO = "D";
  TIPO_CREDITO = "C";
  constructor(props) {
    super(props);
    
   
    this.getInitialState = this.getInitialState.bind(this);
    this.state = this.getInitialState();
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  getInitialState = () => ({
    operConfirmada: false,
    nroOperacion: "",
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };
  componentDidMount() {
    this.initData();
  }
  initData = () => {
    
  };    

  transferir() {
    return TransferCuentasPropiasService.transferir(
      this.props.cuentaOrigen,
      this.props.cuentaDestinoSelected,
      parseFloat(splitImporte(this.props.importe))
    );
  }
    
  confirmarBtn = () => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");  
    trackPromise(
      this.transferir().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);        
        if (jData.codigoRetorno === "0") {
                this.btn.removeAttribute("disabled");
                this.props.returnDataPaso2(jData.numeroOperacion);
                this.nextStep.click();
        } else {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
        }
      })
    ).catch(function (error) {
      //// Habilita boton
      this.btn.removeAttribute("disabled");
      //console.log(error);
    });
  };

 
  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {this.props.cuentaOrigenSelected !== undefined && (
          <ConfirmarOperacionTransfer          
            items={this.props.itemsConfirm}
            detalleCuentaBox={this.props.detalleCuenta}
            tipoCuenta={this.props.cuentaOrigenSelected.descripcion}
            moneda={this.props.cuentaOrigenSelected.moneda}
            nroOperacion={""}
          />
        )}

        <hr/>  

        <div className="row">
          <div className="col-lg-7 col-md-6">
              <label className="input-label-bold" style={{marginTop:10}}>
                Esta seguro que desea CONFIRMAR la operación?<br/>
              </label>
          </div>
          <div className="col-lg-2 col-md-3 btn-consulta">    
              <button
                onClick={this.props.previousStep}
                type="button"
                className="btn btn-cu-quintary">
               <FontAwesomeIcon icon={faArrowLeft} />  Volver
              </button>
            
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}></button>
              <button
                hidden
                ref={(a) => (this.previousStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.previousStep}></button>
            </div>
          
          <div className="col-lg-3 col-md-3">
          <button ref={btn => { this.btn = btn; }}
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary"
                onClick={this.confirmarBtn}>
                Confirmar Transferencia <FontAwesomeIcon icon={faArrowRight} />
              </button>
              </div>     
        </div>
      </div>
    );
  }
}
